/* @flow */
import * as React from 'react';

export function formatNumber(originalPhone: string): string {
  // Format North American numbers without country code.
  if (originalPhone.startsWith('+1')) {
    return formatNumber(originalPhone.substr(2));
  }

  // if number starts with a +, assume international format and don't touch it
  if (originalPhone[0] === '+') {
    return `+${originalPhone.replace(/\D/g, '')}`;
  }

  // otherwise assume US number, format like (nnn) nnn-nnnn
  let phone = originalPhone.replace(/\D/g, '');
  let formatted = phone.substr(0, 3);
  if (phone.length > 3) {
    formatted = `(${formatted}) ${phone.substr(3, 3)}`;
  }
  if (phone.length > 6) {
    formatted += `-${phone.substr(6, 4)}`;
  }
  return `${formatted}`;
}

type Props = {
  onChange: (text: string) => void,
  style?: any,
  value?: string,
};

class PhoneNumberInput extends React.Component<Props> {
  _onChange = ({ target: { value } }: SyntheticInputEvent<>) => {
    let stripFormattedValue = value.replace(/[ ()]/g, '');
    this.props.onChange(
      stripFormattedValue[0] === '+' ? stripFormattedValue : `+1${stripFormattedValue}`
    );
  };

  render() {
    const { value, ...otherProps } = this.props;
    return (
      <input
        {...otherProps}
        type="text"
        value={formatNumber(value || '')}
        onChange={this._onChange}
      />
    );
  }
}

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./src/ui/components/PhoneNumberInput.js